import { render, staticRenderFns } from "./ProductoCatalogo.vue?vue&type=template&id=69135a9a&"
import script from "./ProductoCatalogo.vue?vue&type=script&lang=js&"
export * from "./ProductoCatalogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports